<template>
  <v-app>
    <router-view />
    <app-notification />
    <upload-progress />
  </v-app>
</template>

<script lang="ts" setup>
  import { useAppTheme } from '@/composables/useTheme';

  useAppTheme();
</script>
